import { useState } from "react";
import { CURRENCIES, useCurrency } from "@/context/CurrencyContext";
import { DollarSign } from "lucide-react";

export default function CurrencySwitcher({ variant = "header" }) {
  const { currency, setCurrency, info } = useCurrency();
  const [open, setOpen] = useState(false);

  const isDark = variant === "dark";
  const base = isDark
    ? "bg-transparent text-white border-white/40 hover:bg-white/10"
    : "bg-white text-[#0A0A0A] border-[#0A0A0A] hover:bg-[#F4F4F0]";

  return (
    <div className="relative" data-testid="currency-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-2 font-mono-mark text-[10px] px-3 py-2 border ${base}`}
        data-testid="currency-switcher-btn"
      >
        <DollarSign className="w-3 h-3" />
        <span>{info.code}</span>
        <span className="text-xs leading-none">{info.flag}</span>
      </button>
      {open && (
        <div className={`absolute right-0 top-full mt-1 w-56 ${isDark ? "bg-[#0A0A0A] text-white border-white/40" : "bg-white border-[#0A0A0A]"} border brutal-shadow z-50 max-h-80 overflow-y-auto`} data-testid="currency-switcher-menu">
          {CURRENCIES.map((c) => (
            <button
              key={c.code}
              onClick={() => { setCurrency(c.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3 py-2 font-mono-data text-sm text-left ${c.code === currency ? (isDark ? "bg-white/10" : "bg-[#FFD600]") : ""} hover:bg-[#F4F4F0] hover:text-[#0A0A0A]`}
              data-testid={`currency-${c.code}`}
            >
              <span className="flex items-center gap-2 min-w-0">
                <span className="shrink-0">{c.flag}</span>
                <span className="truncate">{c.name}</span>
              </span>
              <span className="font-mono-mark text-[9px] opacity-60 shrink-0">{c.code}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
